import FakeUserPictures from './FakeUserPictures';

export default FakeUserPictures;
